import {VideoEventAbstract} from 'app/components/tv/events/VideoEvent';

export default class VideoAdsInitializedEvent extends VideoEventAbstract {}
